module.exports=/[\0-\x1F\x7F-\x9F]/


//////////////////
// WEBPACK FOOTER
// ./node_modules/uc.micro/categories/Cc/regex.js
// module id = 345
// module chunks = 0